import { render, staticRenderFns } from "./CodigoParaIntegracaoExterna.vue?vue&type=template&id=f158e5bc&"
import script from "./CodigoParaIntegracaoExterna.vue?vue&type=script&lang=js&"
export * from "./CodigoParaIntegracaoExterna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports